import { render, staticRenderFns } from "./InvoiceDropzone.vue?vue&type=template&id=6f44933c&"
import script from "./InvoiceDropzone.vue?vue&type=script&lang=js&"
export * from "./InvoiceDropzone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports